'use strict';

function arrayUtilsController() {
  'ngInject';

  const vm = {};

  vm.extend = function (a, b) {
    for (const x of b) {
      a.push(x);
    }
  }

  return vm;
}

export default arrayUtilsController;
